import { Component } from "solid-js";

interface HiddenGemsIconProps {
  class?: string;
}

export const HiddenGemsIcon: Component<HiddenGemsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 21.3355C16 18.3888 18.3888 16 21.3356 16C18.3888 16 16 13.6112 16 10.6644C16 13.6112 13.6112 16 10.6644 16C13.6112 16 16 18.3888 16 21.3355Z"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.005 16C28.005 22.6302 22.6302 28.005 16 28.005C9.36982 28.005 3.995 22.6302 3.995 16C3.995 9.36982 9.36982 3.995 16 3.995"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.3372 10.6645C25.3372 8.45441 27.1288 6.6628 29.3389 6.6628C27.1288 6.6628 25.3372 4.87119 25.3372 2.66113C25.3372 4.87119 23.5456 6.6628 21.3356 6.6628C23.5456 6.6628 25.3372 8.45441 25.3372 10.6645Z"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
